import { render, staticRenderFns } from "./LandingpageAGB.vue?vue&type=template&id=326afc17&"
import script from "./LandingpageAGB.vue?vue&type=script&lang=js&"
export * from "./LandingpageAGB.vue?vue&type=script&lang=js&"
import style0 from "./LandingpageAGB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports